<template>
  <div>
    <label>I want to make the investment in</label>
    <div v-for="option in registeredOptions" class="radio radio-primary">
      <input type="radio" :id="option.trusteeId" v-on:click="getTrusteeName(option.trusteeName)" name="registration_status" :value="option.trusteeId" @change="trusteeChanged($event)" :checked="option.trusteeId === status"/>
      <label >{{ option.label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    registeredOptions : { type: Array },
    registeredDefaults : { type: Object }
  },
  data() {
    return {
      name: 'registration_status',
      trustee : this.registeredDefaults.trustee,
      status : this.registeredDefaults.status
    }
  },
  methods : {
    trusteeChanged(event) {
      this.$root.$emit('trusteeChanged',{'value':event.target.value,'name':this.trustee})
      this.status = event.target.value
    },
    getTrusteeName(trusteeName) {
       this.trustee = trusteeName
    }
  }
}
</script>